import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=13e41d0e&scoped=true&"
var script = {}
import style0 from "./Return.vue?vue&type=style&index=0&id=13e41d0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e41d0e",
  null
  
)

export default component.exports